import {ISessionCoolDownHandler} from "./session-cooldown-handler.interface";

export class VoidSessionCoolDownHandler implements ISessionCoolDownHandler  {
    async applyRestriction(): Promise<void> {

    }
    showCoolDown(): void {

    }
    continueCoolDown(): void {

    }

    dispose(): void {
    }

}
